import React, { Component } from "react";

import { Box, Text, ButtonGroup, Button } from '@chakra-ui/react';

import { AgGridReact } from "ag-grid-react";
// import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileImport, faRecycle } from "@fortawesome/free-solid-svg-icons";


import CoreService from "../../../services/CoreService";


const GRIDCOLSTATE = "gridcolstate";
const GRIDSORTMODE = "gridsortmode";
const GRIDFILTERMODE = "gridfiltermode";

const columnDefs =
    [
        { headerName: "Display Value", field: "name", sortable: true, filter: true, resizable: true, minWidth: 300 },
        { headerName: "Data Value", field: "id", sortable: true, filter: true, resizable: true, maxWidth: 600 }
    ];


export default class ListDetailGrid extends Component {
    constructor(props) {
        super(props);
        this.coreService = new CoreService();
        this.state = {
            schema: null,
            gridData: [],
            isLoading: true
        }
        this.requestGridDataRefresh = this.requestGridDataRefresh.bind(this);
        this.refreshGridData = this.refreshGridData.bind(this);
    }

    async componentDidMount() {
        // await this.refreshGridData();
        this.setState({
            gridData: this.props.subList
        })
    }


    async refreshGridData() {
        this.setState({ isLoading: true });
        var gridDataResponse = await this.coreService.fetchIdNameDataList(this.props.currentList.listName, this.props.userSession.gcid, this.props.userSession.token);
        var newGridData = gridDataResponse.dataResult.data;
        console.log("the new grid data");
        console.log(newGridData);
        this.setState({
            gridData: newGridData,
            isLoading: false
        });
    }

    onEditGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
    };

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.resetRowHeights();
        this.gridApi.sizeColumnsToFit();
    };

    async requestGridDataRefresh(e) {
        // await this.refreshGridData();
        this.props.onToastRequest("information", "List Data Refreshed");
    }





    render() {

        const divStyle = {
            width: "100%",
            height: "40vh"

        };

        // const gridData = (this.props.subList) ? this.state.gridData : [{}];
        // const loadingIcon = this.state.isLoading ? (
        //     <FontAwesomeIcon icon={faSyncAlt} color="green" spin />
        // ) : (
        //     ""
        // );
        const listName = (this.props.currentList) ? this.props.currentList.description : "";

        return (

            <Box>
                <Text fontSize={{ base: '30px', md: '36px', lg: '40px' }} color='white'>{listName}</Text>

                <Button
                    variant="solid"
                    leftIcon={<FontAwesomeIcon icon={faFileImport} />}
                    bg='#0095c8'
                    color='white'
                    fontSize={{ base: '12px', md: '14px', lg: '18px' }}
                    onClick={this.props.onImportRequest}
                >
                Import
                </Button>


                <div className="ag-theme-balham" style={divStyle}>
                    <AgGridReact
                        rowSelection="single"
                        enableRangeSelection={false}
                        pagination={true}
                        columnDefs={columnDefs}
                        rowData={this.props.subList}
                        animateRows={true}
                        onGridReady={this.onGridReady}
                    />
                </div>

            </Box>

        );
    }
}